import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import './Categories2.css';

const Categories2 = () => {
  const [CategoryUser, setCategoryUser] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get(
        "https://cyberathon.com/streekatha/API/index.php/Master_controller/list_main_category"
      );

      if (response.data && Array.isArray(response.data.row)) {
        setCategoryUser(response.data.row);
      } else {
        setCategoryUser([]);
      }
    };

    fetchData();
  }, []);

  return (
    <nav className="category-nav border-bottom">
       <div className="container">
      <h2 className="simple-title">Trending Categories</h2>
    </div>
      <div className="container p-0">
        <div className="nav-items bg-white pb-3">

          {CategoryUser.map((category) => (
  <Link
    to={`/subcategory/${category.category_id}`}
    className="text-decoration-none"
    key={category.category_id}
  >

              <button
                className="btn p-0 d-flex flex-column align-items-center gap-2                  border-0 bg-transparent"
                style={{ minWidth: "fit-content" }}
              >
                <div
                  className="nav-main d-flex align-items-center justify-content-center"
                >
                  {/* No category image in your new API, so default icon */}
                  <img
                    src={`https://cyberathon.com/multivendor/${category.image}`}
                    alt="category"
                    className="navitems-image"
                  />
                </div>

                <span className="small fw-medium text-dark text-nowrap">
                  {category.category_name}
                </span>
              </button>
            </Link>
          ))}

        </div>
      </div>
    </nav>
  );
};

export default Categories2;


